import { createSlice } from '@reduxjs/toolkit';
// Slice dla aktywnej zakładki w użytkownikach
const sportsSlice = createSlice({  
  name: 'sports', // Nazwa slice'a
  initialState: {
    checkedItems: [], // Lista zaznaczonych checkboxów
    activeUsersTab: 'Dyscypliny', // Domyślna aktywna zakładka
    currentPage: 1, // Domyślna strona
    maxPages: 2, // Domyślna maksymalna liczba stron
    sortBy: null,
    sortDirection: null, // Domyślny kierunek sortowania
    
    addModalOpen: false, // Stan modala dodawania

    keyword: '', // Wyszukiwana fraza
    searchValue: '', // Wartość wyszukiwania

    editModalOpen: false, // Stan modala edycji
    editedSport: null, // Dane edytowanego sportu
    needRefresh: 1, // Flaga do wymuszenia odświeżenia
    sortSortListEndpoint: "ALPHABETICALLY"
  },
  reducers: {  
    toggleSortListEndpoint: (state) => {
  
      if (state.sortSortListEndpoint === "ALPHABETICALLY") {
        state.sortSortListEndpoint = "ORDER_NUMBER";
      } else if (state.sortSortListEndpoint === "ORDER_NUMBER") {
        state.sortSortListEndpoint = "ALPHABETICALLY";
      }
    },
    setSortListEndpoint: (state, action) => {
      state.sortSortListEndpoint = action.payload; // Ustawienie endpointu sortowania
    },
    toggleNeedRefresh: (state) => {
      state.needRefresh = state.needRefresh === 1 ? 0 : 1; // Przełączanie flagi odświeżenia
    },
    toggleCheckedItem: (state, action) => {
      const id = action.payload;
      if (state.checkedItems.includes(id)) {
        // Usuń id, jeśli już istnieje
        state.checkedItems = state.checkedItems.filter((item) => item !== id);
      } else {
        // Dodaj id, jeśli nie istnieje
        state.checkedItems.push(id);
      }
    },
    setPage(state, action) {
          state.checkedItems = []; // Resetowanie zaznaczonych elementów przy zmianie strony
          state.currentPage = action.payload;
        },
    setMaxPages(state, action) {
          state.maxPages = action.payload; // Aktualizacja maksymalnej liczby stron 
        },
    setSorting(state, action) {
        state.checkedItems = []; // Resetowanie zaznaczonych elementów przy zmianie strony
        const { sortBy, sortDirection } = action.payload;
        state.sortBy = sortBy;
        state.sortDirection = sortDirection;
      },
      toggleAddModal(state) {
        state.addModalOpen = !state.addModalOpen; // Przełączanie stanu modala dodawania
      },
      toggleEditModal(state, action) {
        state.editModalOpen = !state.editModalOpen;
        state.editedSport = action.payload || null; // Ustaw dane edytowanego sportu lub resetuj
      },
      clearCheckedItems: (state) => {
        state.checkedItems = []; // Resetowanie zaznaczonych elementów
      },
      setKeyword: (state, action) => {
        state.keyword = action.payload; // Ustawienie wyszukiwanej frazy
      },
      setSearchValue: (state, action) => {
        state.searchValue = action.payload; // Ustawienie wartości wyszukiwania
      },
}});

export const {
  toggleNeedRefresh,
  toggleCheckedItem,
  setPage,
  setMaxPages,
  setSorting,
  toggleAddModal,
  toggleEditModal,
  clearCheckedItems,
  setKeyword,
  setSearchValue,
  toggleSortListEndpoint,
  setSortListEndpoint,
 } = sportsSlice.actions; // Eksport akcji
export default sportsSlice.reducer;